import React from 'react';
import { cn } from '@/lib/utils';

const base = 'tracking-[0%] font-primary';

// Valid tag names for semantic rendering
const validTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div', 'span', 'p'];

// Visual style classes mapped by variant
const variants = {
  default: 'text-red',
  '1': 'font-semibold text-primary text-[2.625rem]/[1] sm:text-5xl/[1]',
  '2': 'font-semibold text-primary text-xl/[1] sm:text-[2rem]/[1]',
  '3': 'font-medium text-primary text-base/5 sm:text-[1.75rem]/6 sm:font-semibold',
  '4': 'font-medium text-primary text-[0.9375rem]/6 sm:text-2xl/6',
  '5': 'font-semibold text-secondary text-lg/[1] sm:text-[1.375rem]/[1]',
  '6': 'font-medium text-affidea-gray-dark text-base/6 sm:text-xl/6',
  userAccountTitle: 'font-semibold text-primary text-xl/[1] sm:text-2xl/[1]',
  userAccountDetailsTitle: 'font-semibold text-primary text-base/[1] sm:text-xl/[1]',

};

export const Heading = ({
  as = 'div',               // HTML tag to render (h1, div, etc.)
  variant = 'default',     // Style variant name
  children,
  className,
  ...props
}) => {
  const Tag = validTags.includes(as) ? as : 'div';
  const style = variants[variant] || variants['default'];

  return (
    <Tag className={cn(base, style, className)} {...props}>
      {children}
    </Tag>
  );
};
